<template>
  <b-modal
    id="page-not-visible"
    ok-only
    @ok="returnToOverview">
    <p>
      {{ pageName }} cannot be accessed because the Project Approval Status
      is "{{ project.approvalStatus }}".
    </p>
  </b-modal>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'ProjectBudget',
  props: {
    pageName: String,
    project: {
      type: Object,
      default: () => ({}),
    },
    unallowedStatuses: {
      type: Array,
    },
  },
  data() {
    return {
      unallowedSubmitStatuses: [],
    };
  },
  computed: {
    ...mapState(['config']),
  },
  mounted() {
    this.$store.dispatch('fetchConfiguration').then(() => {
      if (this.unallowedStatuses && this.unallowedStatuses.length > 0) {
        this.unallowedSubmitStatuses = this.unallowedStatuses;
      } else {
        this.unallowedSubmitStatuses = [
          this.config.projectOverviewPage.submitStatus.ConceptRejected,
          this.config.projectOverviewPage.submitStatus.Draft,
          this.config.projectOverviewPage.submitStatus.SubmittedForPlanningApproval,
        ];
      }
      if (this.project && this.unallowedSubmitStatuses.includes(this.project.approvalStatus)) {
        this.$bvModal.show('page-not-visible');
      }
    });
  },
  methods: {
    returnToOverview() {
      this.$router.push({ path: `/project/${this.project.id}/overview` });
    },
  },
};
</script>
